import React from 'react'
import styles from './popUpStyles'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography';
import {withStyles} from '@material-ui/core/styles'
import WarningIcon from '@material-ui/icons/Warning'
import ErrorIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/NotificationImportant'
import Slide from '@material-ui/core/Slide'
//props needs
// type = string (error, warning, info)
// title = string
// content = string
// type = string (error, warring, info)
// buttons = array with objects buttons[{title: 'Beispiel', onCLick: function}]

const PopUp = ({title, content, userInput, type, buttons, classes, }) => {
    // eslint-disable-next-line
    let withUserInput = false
    // eslint-disable-next-line
    let userInputValue =''
    let icon = null
    let styleHeader = {
        color: '#3f51b5'
    }
   
    switch (type) {
        case 'error':
            styleHeader.color = 'red'
            icon = <ErrorIcon className={classes.icons} />
            break;
        case 'warning':
            // eslint-disable-next-line
            styleHeader.color = 'red',
            icon = <WarningIcon className={classes.icons} color='inherit' />
            break;
        case 'info':
            // eslint-disable-next-line
            styleHeader.color = '#3f51b5',
            alert('info')
            icon = <InfoIcon className={classes.icons} color='primary' />
            break;
        default:
            // eslint-disable-next-line
            styleHeader.color = '#3f51b5',
            icon = <InfoIcon className={classes.icons} color='primary' />
            break;
    }
    
    typeof(userInput)==='undefined' ? withUserInput=false : withUserInput=true

    return (
        <Slide in={true} direction='down'>
            <div className={classes.container}>
                <div className={classes.wrapper}>
                    <Paper className={classes.paper} >
                        <div style={styleHeader}>
                            <div>
                                {icon}
                                <Typography className={classes.title} variant='title' color='inherit'>
                                    {title}
                                </Typography>
                            </div>
                        </div>
                        <div className={classes.contentWrapper}>
                            <div className={classes.content}>
                                <Typography variant='subheading'>
                                    {content}
                                </Typography>
                                {typeof(userInput)!=='undefined'
                                ?<div style={{marginTop: '8px'}} >Bitte Begründung eingeben:<br/> <input autoComplete='off' style={{width: '80%', marginTop: '8px'}} type='textarea' onChange={e=>userInput(e)} autoFocus/>
                                </div>
                                : null}
                            </div>
                            
                        </div>
                        <div className={classes.footer}>
                            <Buttons 
                                buttons={buttons}
                                classes={classes}
                            />
                        </div>
                    </Paper>
                </div>
            </div>
        </Slide>
    )
}


const Buttons = ({buttons, classes}) => {
    
   
    return (
        <div className={classes.buttonWrapper}>
            {buttons.map((button, index) => <Button
                                                disabled={button.disabled || false}
                                                 className={classes.button}
                                                 key={index} size='small'
                                                 variant='contained'
                                                 color={button.color || 'primary'}
                                                 onClick={()=>button.onClick()}
                                            >{button.title}</Button>)}
        </div>
       
    )
}

export default withStyles(styles)(PopUp)


// WEBPACK FOOTER //
// ./src/Container/PopUps/PopUp.js